import moment from 'moment';

export const columns = ({ t }) => [
  {
    title: t('Name'),
    name: 'name'
  },
  {
    title: t('Description'),
    name: 'description'
  },
  {
    title: t('Last Updated Date'),
    name: 'updatedAt'
  },
  {
    title: t('Last Updated By'),
    name: 'lastUpdatedBy'
  }
];

export const formatData = items =>
  items.map(item => ({
    ...item,
    updatedAt: moment(item.changedUtc)
      .format('ll')
      .toUpperCase(),
    lastUpdatedBy: `${item.changedByUser.firstName} ${
      item.changedByUser.lastName
    }`
  }));

export default {
  columns,
  formatData
};
